import { useEffect } from 'react';
import useAuthStore from '@pkg/auth/useStore';
import Database from '@pkg/database/Database';
import useMutations from './useMutations';
import useRefresh from './useRefresh';
import useStore from './useStore';

export default function useLive() {
  const { isAuthenticated, isLoading } = useAuthStore();
  const { refresh, isRefreshing } = useRefresh();
  const setActivities = useStore((state) => state.setActivities);
  const setLoading = useStore((state) => state.setLoading);
  const setMutations = useStore((state) => state.setMutations);
  const mutations = useMutations();

  const isStale = Database.useStaleHash('activities');
  const activities = Database.useLive('activities');

  useEffect(() => {
    if (isLoading || isRefreshing) {
      return;
    }

    if (!isAuthenticated) {
      setActivities([]);
      setLoading(false);
      return;
    }

    if (isStale) {
      refresh();
      return;
    }

    if (!activities) {
      return;
    }

    setActivities(activities);
    setLoading(false);
  }, [activities, isAuthenticated, isLoading, isRefreshing, isStale]);

  useEffect(() => {
    setMutations(isAuthenticated ? mutations : {});
  }, [isAuthenticated, mutations]);
}
